import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\'info-message {{info-message-class (or @type \"info\")}}\'\n  ...attributes\n>\n  {{yield}}\n</div>")